if (!customElements.get('anniversary-motion-film')) {
  class AnniversaryMotionFilm extends HTMLElement {
    connectedCallback() { this.setup(); }

    disconnectedCallback() { this.cleanup(); }

    setup() {
      this.cleanup();
      this.section = this.closest('.anniversary-motion-film');
      this.pin = this.querySelector('[data-motion-film-pin]');
      this.items = [...this.querySelectorAll('[data-motion-film-statement]')];
      this.responsiveScene = this.querySelector('[data-motion-film-responsive-scene]');
      this.desktopMosaic = this.querySelector('[data-motion-film-desktop-mosaic]');
      this.desktopMosaicTemplate = this.querySelector('[data-motion-film-desktop-mosaic-template]');
      this.desktopMediaQuery = matchMedia(this.responsiveScene ? '(min-width: 1280px)' : 'all');
      this.mountDesktopMosaic();
      this.images = [...this.querySelectorAll('.anniversary-motion-film__image')];
      this.items.forEach((item) => { item.hidden = false; });
      this.images.forEach((image) => { image.hidden = false; });
      this.buttons = [...this.querySelectorAll('[data-motion-film-target]')];
      this.videoFrame = this.querySelector('[data-motion-film-video]');
      this.videoOverlay = this.querySelector('[data-motion-film-video-overlay]');
      this.videoTitle = this.querySelector('[data-motion-film-video-title]');
      this.previewVideos = [...this.querySelectorAll('[data-motion-film-video-preview]')];
      this.youtubePopup = this.querySelector('[data-motion-film-youtube-popup]');
      this.player = this.querySelector('[data-motion-film-youtube-player]');
      this.openButton = this.querySelector('[data-motion-film-video-play]');
      this.closeButton = this.querySelector('[data-motion-film-youtube-close]');
      this.videoHasReachedFull = false;
      this.videoTimelineEnd = window.innerWidth <= 767 ? 1 : 0.85;
      this.storyTimelineEnd = 0.82;
      this.videoTransitionStart = 0.8;
      this.videoTransitionEnd = 0.92;
      this.sceneRanges = [
        { start: 0.04, enterEnd: 0.08, holdEnd: 0.19, exitEnd: 0.27 },
        { start: 0.35, enterEnd: 0.41, holdEnd: 0.48, exitEnd: 0.56 },
        { start: 0.65, enterEnd: 0.71, holdEnd: 0.78, exitEnd: 0.82 },
      ];
      this.mediaAbortController = new AbortController();
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.heroImageFrameProgress = [0, 0.12, 0.27, 0.41, 0.56, 0.71, this.storyTimelineEnd];
      // Figma frames keep the composite centered and change only its scale.
      // The first frame is the 274px-wide reference state on both viewports.
      this.responsiveSceneScales = {
        mobile: [1, 380 / 274, 574 / 274, 574 / 274, 725 / 274, 846 / 274, 908 / 274],
        tablet: [1, 380 / 274, 574 / 274, 574 / 274, 725 / 274, 1028 / 274, 1140 / 274],
      };
      // Direct port of the IFA hero constellation. Values are the 1920px
      // Figma artboard's x/y/width/opacity states for its twelve images.
      this.heroDesktopFrames = [
        [[1186.48, 211.23, 57.331, 0], [1400.19, 361.15, 102.723, 0], [736.93, 499.56, 81.526, 0], [718.97, 227.81, 85.211, 0], [834.58, 301.51, 45.139, 0], [1032.18, 492.2, 25.333, 0], [548.09, 323.62, 130.811, 0], [661.39, 436, 97.647, 0], [1365.65, 479.76, 80.145, 0], [1280.9, 238.87, 130.811, 0], [1243.59, 503.25, 80.145, 0], [1127.06, 409.75, 80.145, 0]],
        [[1213.21, 183.12, 66.852, 0], [1462.42, 357.94, 119.782, 1], [689.01, 519.34, 95.065, 0], [668.07, 202.45, 99.362, 1], [802.87, 288.39, 52.635, 0], [1033.29, 510.74, 29.54, 0], [428.8, 314.17, 152.534, 1], [584.41, 452.41, 113.864, 0], [1442.14, 486.24, 93.454, 0], [1323.32, 215.34, 152.534, 0], [1279.81, 523.63, 93.454, 1], [1143.93, 414.6, 93.454, 0]],
        [[1290.72, 101.62, 94.457, 1], [1643.83, 348.63, 169.242, 1], [550.07, 576.67, 134.32, 1], [520.47, 128.93, 140.391, 1], [710.95, 250.35, 74.369, 0], [1036.5, 564.53, 41.738, 1], [198.93, 286.78, 215.519, 1], [425.61, 471.94, 160.88, 0], [1585.93, 544.04, 132.043, 0], [1446.29, 147.15, 215.519, 0], [1384.82, 582.74, 132.043, 0], [1192.83, 428.69, 132.043, 0]],
        [[1375, 13, 124, 1], [1839, 338.5, 223, 1], [399, 639, 177, 1], [360, 49, 185, 1], [611, 209, 98, 1], [1040, 623, 55, 1], [-51, 257, 284, 0], [235, 501, 212, 0], [1764, 596, 174, 0], [1580, 73, 284, 0], [1499, 647, 174, 0], [1246, 444, 174, 1]],
        [[1453.39, -69.43, 152.389, 1], [2021.44, 329.08, 273.04, 1], [258.48, 696.98, 216.7, 1], [210.73, -25.35, 226.494, 0], [518.03, 170.53, 119.981, 1], [1043.25, 677.39, 67.336, 1], [-283.48, 229.3, 347.699, 0], [58.7, 528.03, 259.55, 0], [1929.64, 644.34, 213.027, 1], [1704.37, 4.03, 347.699, 0], [1605.2, 706.77, 213.027, 1], [1295.46, 458.24, 213.027, 1]],
        [[1467.73, -84.5, 157.494, 1], [2054.8, 327.36, 282.187, 1], [232.78, 707.58, 223.96, 0], [183.44, -38.95, 234.082, 1], [501.03, 163.5, 124, 1], [1043.85, 687.34, 69.592, 1], [-325.99, 224.23, 359.348, 0], [25.27, 532.97, 268.245, 1], [1959.93, 653.17, 220.164, 1], [1727.11, -8.58, 359.348, 0], [1624.62, 717.7, 220.164, 0], [1304.5, 460.85, 220.164, 0]],
        [[1572.23, -194.39, 194.711, 1], [2298.04, 314.8, 348.872, 0], [45.46, 784.88, 276.884, 0], [-15.55, -138.07, 289.399, 1], [377.09, 112.22, 153.303, 0], [1048.18, 759.85, 86.037, 1], [-595.91, 187.31, 444.266, 0], [-211.09, 569, 331.635, 0], [2180.75, 717.61, 272.191, 0], [1892.91, -100.53, 444.266, 0], [1766.2, 797.39, 272.191, 0], [1370.43, 479.83, 272.191, 0]],
      ];
      this.heroMobileFrames = [
        {},
        {},
        { 0: [61, 22, 15], 1: [87, 55, 29], 2: [8, 70, 27], 3: [18, 27, 19], 5: [42, 42, 9], 6: [0, 39, 31] },
        { 0: [62, 18, 17], 1: [90, 54, 32], 2: [3, 73, 30], 3: [14, 24, 22], 4: [28, 33, 18], 5: [22, 42, 12], 11: [58, 63, 22] },
        { 0: [61, 14, 18], 1: [98, 51, 38], 2: [-5, 74, 34], 4: [29, 29, 19], 5: [43, 46, 8], 8: [91, 74, 31], 10: [45, 75, 28], 11: [62, 62, 19] },
        { 0: [58, 7, 20], 1: [110, 49, 46], 3: [-5, 14, 31], 4: [25, 24, 22], 5: [44, 36, 9], 7: [-32, 73, 37], 8: [98, 84, 38] },
        {},
      ];
      // Figma's mobile constellation has no Banner 7. Its authored frame
      // data still contains that historical slot, so rendered images skip it.
      this.heroImageIndexMap = [0, 1, 2, 3, 4, 6, 7, 8, 9, 10, 11];
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onButtonClick = this.onButtonClick.bind(this);
      this.onOpen = this.onOpen.bind(this);
      this.onCloseButton = this.onCloseButton.bind(this);
      this.onPopupClick = this.onPopupClick.bind(this);
      this.onDialogClose = this.onDialogClose.bind(this);
      this.onDesktopMediaChange = this.onDesktopMediaChange.bind(this);
      this.buttons.forEach((button) => button.addEventListener('click', this.onButtonClick));
      this.openButton?.addEventListener('click', this.onOpen);
      this.closeButton?.addEventListener('click', this.onCloseButton);
      this.youtubePopup?.addEventListener('click', this.onPopupClick);
      window.addEventListener('resize', this.onResize, { passive: true });
      this.desktopMediaQuery.addEventListener('change', this.onDesktopMediaChange);
      this.youtubePopup?.addEventListener('close', this.onDialogClose);
      this.previewObserver = new IntersectionObserver((entries) => {
        this.isInView = entries.some((entry) => entry.isIntersecting);
        if (this.isInView) {
          this.loadActivePreview();
        } else {
          this.videoHasReachedFull = false;
          this.resetPreview();
        }
      }, { threshold: 0.01 });
      this.previewObserver.observe(this);
      // The opening statement belongs to progress 0, including direct anchor jumps.
      this.section?.classList.add('is-copy-ready');
      this.updateSectionHeight();
      this.connectScrollDriver();
      this.onResize();
    }

    mountDesktopMosaic() {
      if (!this.desktopMediaQuery?.matches || !this.desktopMosaic || !this.desktopMosaicTemplate) return;
      if (!this.desktopMosaic.childElementCount) {
        this.desktopMosaic.append(this.desktopMosaicTemplate.content.cloneNode(true));
      }
      this.images = [...this.desktopMosaic.querySelectorAll('.anniversary-motion-film__image')];
    }

    unmountDesktopMosaic() {
      this.desktopMosaic?.replaceChildren();
      this.images = [];
    }

    onDesktopMediaChange(event) {
      if (event.matches) {
        this.mountDesktopMosaic();
      } else {
        this.unmountDesktopMosaic();
      }
      this.onResize();
    }

    cleanup() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.desktopMediaQuery?.removeEventListener('change', this.onDesktopMediaChange);
      window.clearTimeout(this.gsapTimer);
      this.gsapTimer = null;
      if (this.scrollTrigger && typeof this.scrollTrigger.kill === 'function') {
        this.scrollTrigger.kill();
      }
      this.scrollTrigger = null;
      if (this.progressTween && typeof this.progressTween.kill === 'function') {
        this.progressTween.kill();
      }
      this.progressTween = null;
      this.buttons?.forEach((button) => button.removeEventListener('click', this.onButtonClick));
      this.openButton?.removeEventListener('click', this.onOpen);
      this.closeButton?.removeEventListener('click', this.onCloseButton);
      this.youtubePopup?.removeEventListener('click', this.onPopupClick);
      this.youtubePopup?.removeEventListener('close', this.onDialogClose);
      this.previewObserver?.disconnect();
      this.copyObserver?.disconnect();
      this.section?.classList.remove('is-copy-ready');
      this.mediaAbortController?.abort();
      cancelAnimationFrame(this.raf);
      this.unmountDesktopMosaic();
      this.unloadPreviews();
      this.closePopup(false);
    }

    updateSectionHeight() {
      if (!this.section) return false;
      const step = Number.parseFloat(getComputedStyle(this.section).getPropertyValue('--amf-step')) || 260;
      const release = Number.parseFloat(getComputedStyle(this.section).getPropertyValue('--amf-release')) || 160;
      const videoHold = Number.parseFloat(getComputedStyle(this.section).getPropertyValue('--amf-video-hold')) || 100;
      // Preserve the authored 1080px-screen pacing on taller displays. Without
      // this cap, each configured vh distance doubles on a 4K viewport.
      const referenceViewport = Math.min(window.innerHeight, 1080);
      const isMobile = window.innerWidth <= 767;
      const storyDistance = (step / 100) * referenceViewport * this.sceneRanges.length * (isMobile ? 0.6 : 1);
      const releaseDistance = isMobile ? 0 : (release / 100) * referenceViewport;
      const videoHoldDistance = isMobile ? 0 : (videoHold / 100) * referenceViewport;
      const minHeight = `${Math.ceil(window.innerHeight + storyDistance + releaseDistance + videoHoldDistance)}px`;
      const hasChanged = this.section.style.minHeight !== minHeight;

      if (hasChanged) this.section.style.minHeight = minHeight;
      return hasChanged;
    }

    onResize() {
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(() => {
        if (!this.section) return;
        this.videoTimelineEnd = window.innerWidth <= 767 ? 1 : 0.85;
        const hasHeightChanged = this.updateSectionHeight();
        this.videoHasReachedFull = false;
        if (this.isInView) {
          this.loadActivePreview();
        }
        if (hasHeightChanged && this.scrollTrigger && window.ScrollTrigger?.refresh) {
          window.ScrollTrigger.refresh();
        }
        this.onScroll();
      });
    }

    connectScrollDriver() {
      const gsap = window.gsap;
      const ScrollTrigger = window.ScrollTrigger || gsap?.core?.globals?.().ScrollTrigger;

      if (!this.reduce && gsap && ScrollTrigger) {
        gsap.registerPlugin(ScrollTrigger);
        window.removeEventListener('scroll', this.onScroll);
        this.progressState = { value: 0 };
        this.progressTween = gsap.to(this.progressState, {
          value: 1,
          paused: true,
          ease: 'none',
          onUpdate: () => this.renderProgress(this.progressState.value),
        });
        this.scrollTrigger = ScrollTrigger.create({
          id: `anniversary-motion-film-${this.section?.id || 'section'}`,
          trigger: this.section,
          start: 'top top',
          end: 'bottom bottom',
          animation: this.progressTween,
          scrub: window.innerWidth <= 767 ? true : 0.55,
          invalidateOnRefresh: true,
        });
        return;
      }

      window.addEventListener('scroll', this.onScroll, { passive: true });
      if (!this.reduce && this.isConnected && !this.gsapRetryAttempted) {
        this.gsapRetryAttempted = true;
        this.gsapTimer = window.setTimeout(() => this.connectScrollDriver(), 500);
      }
    }

    onScroll() {
      if (!this.section || !this.items.length) return;
      const rect = this.section.getBoundingClientRect();
      const range = Math.max(1, this.section.offsetHeight - innerHeight);
      const scrollProgress = this.clamp(-rect.top / range);
      this.renderProgress(scrollProgress);
    }

    renderProgress(scrollProgress) {
      // Reserve the final portion of the pin as a readable full-screen video hold.
      const progress = this.clamp(scrollProgress / this.videoTimelineEnd);
      this.updateStatements(progress);
      this.updateImages(progress);
      this.updateVideo(progress);
    }

    updateStatements(progress) {
      let strongestOpacity = 0;
      let activeIndex = -1;

      this.items.forEach((item, index) => {
        const state = this.getStatementState(progress, index);

        item.style.opacity = state.opacity.toFixed(3);
        item.style.filter = `blur(${state.blur.toFixed(2)}px)`;
        item.style.transform = 'none';
        item.style.setProperty('--amf-color-progress', state.opacity.toFixed(3));
        item.setAttribute('aria-hidden', String(state.opacity <= 0.05));

        if (state.opacity > strongestOpacity) {
          strongestOpacity = state.opacity;
          activeIndex = index;
        }
      });

      this.buttons.forEach((button, index) => {
        const active = index === activeIndex;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', String(active));
      });
    }

    getStatementState(progress, index) {
      // Mirrors the IFA hero's copy cadence: each line is readable on its own,
      // then fully clears before the following line enters. Image/video frames
      // retain their independent motion timeline.
      const scene = this.getSceneRange(index);

      if (!scene) return { opacity: 0, blur: 10 };

      // Prevent an empty first frame while preserving all authored keyframes
      // after the opening statement's original 4%–8% reveal window.
      if (index === 0 && progress < scene.enterEnd) {
        return { opacity: 1, blur: 0 };
      }

      const enter = this.clamp((progress - scene.start) / (scene.enterEnd - scene.start));
      const exit = this.clamp((scene.exitEnd - progress) / (scene.exitEnd - scene.holdEnd));
      const opacity = Math.min(this.ease(enter), this.ease(exit));

      return {
        opacity,
        blur: (1 - opacity) * 10,
      };
    }

    updateImages(progress) {
      if (innerWidth < 1280 && this.responsiveScene) {
        const state = this.getResponsiveSceneState(progress);
        const finalStatementFade = 1 - this.ease(this.clamp((progress - 0.78) / 0.04));
        const opacity = state.opacity * finalStatementFade;

        this.responsiveScene.style.visibility = opacity <= 0.002 ? 'hidden' : 'visible';
        this.responsiveScene.style.opacity = opacity.toFixed(3);
        this.responsiveScene.style.setProperty('--amf-responsive-scene-scale', state.scale.toFixed(4));
        return;
      }

      this.images.forEach((image, index) => {
        const state = this.getImageState(progress, index);
        const finalStatementFade = 1 - this.ease(this.clamp((progress - 0.78) / 0.04));
        const opacity = state.opacity * finalStatementFade;
        const blur = this.lerp(state.blur, 10, 1 - finalStatementFade);

        image.style.zIndex = String(Math.round(opacity * 10) + index);
        image.style.visibility = opacity <= 0.002 ? 'hidden' : 'visible';
        image.style.opacity = opacity.toFixed(3);
        image.style.filter = `blur(${blur.toFixed(2)}px)`;
        image.style.inset = 'auto';
        image.style.insetInlineStart = `${state.x.toFixed(3)}%`;
        image.style.insetBlockStart = `${state.y.toFixed(3)}%`;
        image.style.inlineSize = `${state.width.toFixed(3)}%`;
        image.style.blockSize = 'auto';
        image.style.transform = 'none';
      });
    }

    getResponsiveSceneState(progress) {
      const frames = this.heroImageFrameProgress;
      const scales = innerWidth >= 768
        ? this.responsiveSceneScales.tablet
        : this.responsiveSceneScales.mobile;
      let fromIndex = 0;
      let toIndex = frames.length - 1;

      for (let index = 0; index < frames.length - 1; index += 1) {
        if (progress <= frames[index + 1]) {
          fromIndex = index;
          toIndex = index + 1;
          break;
        }
      }

      const span = Math.max(0.001, frames[toIndex] - frames[fromIndex]);
      const local = this.ease(this.clamp((progress - frames[fromIndex]) / span));
      const entranceOpacity = this.ease(this.clamp(progress / frames[1]));

      return {
        scale: this.lerp(scales[fromIndex], scales[toIndex], local),
        opacity: entranceOpacity,
      };
    }

    getImageState(progress, imageIndex) {
      const frames = this.heroImageFrameProgress;
      let fromIndex = 0;
      let toIndex = frames.length - 1;

      for (let index = 0; index < frames.length - 1; index += 1) {
        if (progress <= frames[index + 1]) {
          fromIndex = index;
          toIndex = index + 1;
          break;
        }
      }

      const span = Math.max(0.001, frames[toIndex] - frames[fromIndex]);
      const local = this.ease(this.clamp((progress - frames[fromIndex]) / span));
      const start = this.imageStateForFrame(fromIndex, imageIndex);
      const end = this.imageStateForFrame(toIndex, imageIndex);

      return {
        x: this.lerp(start.x, end.x, local),
        y: this.lerp(start.y, end.y, local),
        width: this.lerp(start.width, end.width, local),
        opacity: this.lerp(start.opacity, end.opacity, local),
        blur: this.lerp((1 - start.opacity) * 10, (1 - end.opacity) * 10, local),
      };
    }

    imageStateForFrame(frameIndex, imageIndex) {
      const authoredImageIndex = this.heroImageIndexMap[imageIndex] ?? imageIndex;

      if (innerWidth >= 1280) {
        const state = this.heroDesktopFrames[frameIndex]?.[authoredImageIndex] || [960, 395, 8, 0];
        return {
          x: (state[0] / 1920) * 100,
          y: (state[1] / 790.912109375) * 100,
          width: (state[2] / 1920) * 100,
          opacity: state[3],
        };
      }

      return this.mobileImageStateForFrame(frameIndex, authoredImageIndex);
    }

    mobileImageStateForFrame(frameIndex, imageIndex) {
      const visible = this.heroMobileFrames[frameIndex]?.[imageIndex];
      if (visible) return { x: visible[0], y: visible[1], width: visible[2], opacity: 1 };

      let anchor;
      let distance = Number.POSITIVE_INFINITY;
      this.heroMobileFrames.forEach((frame, candidateIndex) => {
        const candidate = frame[imageIndex];
        if (!candidate || Math.abs(candidateIndex - frameIndex) >= distance) return;
        anchor = candidate;
        distance = Math.abs(candidateIndex - frameIndex);
      });
      const fallback = anchor || [50, 50, 8];
      const isIntro = frameIndex <= 1;
      const isOutro = frameIndex >= this.heroMobileFrames.length - 1;
      const spread = isIntro ? (frameIndex === 0 ? 0.2 : 0.48) : (isOutro ? 1.32 : 0.72);
      const size = isIntro ? (frameIndex === 0 ? 0.4 : 0.62) : (isOutro ? 1.22 : 0.82);

      return {
        x: 50 + ((fallback[0] - 50) * spread),
        y: 50 + ((fallback[1] - 50) * spread),
        width: fallback[2] * size,
        opacity: 0,
      };
    }

    getSceneRange(index) {
      const fallbackStart = 0.04 + (index * 0.2);

      return this.sceneRanges[index] || {
        start: fallbackStart,
        enterEnd: fallbackStart + 0.04,
        holdEnd: fallbackStart + 0.1,
        exitEnd: fallbackStart + 0.15,
      };
    }

    updateVideo(progress) {
      if (!this.videoFrame) return;
      // The film takes over across a long scroll interval, matching the handoff's
      // staged transition while keeping the selected poster visible underneath.
      const enter = this.clamp(
        (progress - this.videoTransitionStart)
        / (this.videoTransitionEnd - this.videoTransitionStart),
      );
      const eased = this.ease(enter);
      const previewOpacity = this.clamp((enter - 0.82) / 0.18);
      const controlsOpacity = this.clamp((enter - 0.9) / 0.1);
      // The cover first settles into the previous visual starting scale before
      // its decorative controls appear, then continues the video handoff.
      const posterDecorationOpacity = this.clamp((eased - 0.12) / 0.12) * (1 - controlsOpacity);
      this.videoFrame.style.opacity = enter.toFixed(3);
      this.videoFrame.style.filter = 'none';
      this.videoFrame.style.transform = `translate3d(0, ${((1 - eased) * 54).toFixed(1)}px, ${(-520 + eased * 520).toFixed(1)}px) scale(${(0.46 + eased * 0.54).toFixed(3)})`;
      this.videoFrame.style.setProperty('--amf-video-preview-opacity', previewOpacity.toFixed(3));
      this.videoFrame.style.setProperty('--amf-video-overlay-opacity', controlsOpacity.toFixed(3));
      this.videoFrame.style.setProperty('--amf-video-poster-decoration-opacity', posterDecorationOpacity.toFixed(3));
      this.videoFrame.style.pointerEvents = enter > 0.78 ? 'auto' : 'none';
      const isVideoOverlayReady = enter >= 0.995;
      this.videoOverlay?.toggleAttribute('data-motion-film-video-overlay-ready', isVideoOverlayReady);
      this.videoOverlay?.toggleAttribute('aria-hidden', !isVideoOverlayReady);
      this.videoOverlay?.toggleAttribute('inert', !isVideoOverlayReady);
      this.updateVideoTitle(isVideoOverlayReady);

      if (enter >= 0.995 && !this.videoHasReachedFull) {
        this.videoHasReachedFull = true;
        this.restartPreview();
      } else if (enter < 0.98 && this.videoHasReachedFull) {
        this.videoHasReachedFull = false;
        this.resetPreview();
      }
    }

    restartPreview() {
      const preview = this.activePreview();
      if (!preview) return;
      if (preview.readyState > HTMLMediaElement.HAVE_NOTHING) preview.currentTime = 0;
      this.playPreview();
    }

    resetPreview() {
      const preview = this.activePreview();
      if (!preview) return;
      preview.pause();
      if (preview.readyState > HTMLMediaElement.HAVE_NOTHING) preview.currentTime = 0;
    }

    activePreview() {
      if (innerWidth >= 1280) return this.querySelector('.anniversary-motion-film__video-preview--pc');
      if (innerWidth >= 768) return this.querySelector('.anniversary-motion-film__video-preview--tablet');
      return this.querySelector('.anniversary-motion-film__video-preview--mobile');
    }

    loadActivePreview() {
      const preview = this.activePreview();
      if (!preview || preview.dataset.loaded === 'true') return;
      const source = preview.dataset.videoSrc;
      if (!source) return;
      preview.src = source;
      preview.dataset.loaded = 'true';
      preview.load();
    }

    playPreview() {
      const activePreview = this.activePreview();
      this.loadActivePreview();
      this.previewVideos.forEach((preview) => {
        if (preview === activePreview) {
          const playback = preview.play();
          playback?.catch(() => {});
        } else {
          preview.pause();
        }
      });
    }

    pausePreview() {
      this.previewVideos?.forEach((preview) => preview.pause());
    }

    unloadPreviews() {
      this.previewVideos?.forEach((preview) => {
        preview.pause();
        preview.removeAttribute('src');
        delete preview.dataset.loaded;
        preview.load();
      });
    }

    onOpen() {
      const videoId = this.videoId();
      if (!videoId || !this.youtubePopup || !this.player) return;
      this.lastFocusedElement = document.activeElement;
      this.player.src = this.embedUrl(videoId);
      if (!this.youtubePopup.open) this.youtubePopup.showModal();
      this.closeButton?.focus({ preventScroll: true });
    }

    onCloseButton() { this.closePopup(); }

    onPopupClick(event) {
      if (event.target === this.youtubePopup) this.closePopup();
    }

    onDialogClose() {
      if (this.player) this.player.removeAttribute('src');
    }

    updateVideoTitle(isVisible) {
      if (!this.videoTitle) return;
      this.videoTitle.style.opacity = isVisible ? '1' : '0';
    }

    closePopup(restoreFocus = true) {
      if (!this.youtubePopup) return;
      if (this.youtubePopup.open) this.youtubePopup.close();
      if (restoreFocus) this.lastFocusedElement?.focus?.({ preventScroll: true });
    }

    onButtonClick(event) { this.scrollTo(Number(event.currentTarget.dataset.motionFilmTarget)); }

    scrollTo(index) {
      const range = Math.max(1, this.section.offsetHeight - innerHeight);
      const target = (this.getSceneRange(index).start + 0.025) * this.videoTimelineEnd;
      window.scrollTo({ top: this.section.getBoundingClientRect().top + scrollY + (range * target), behavior: this.reduce ? 'auto' : 'smooth' });
    }

    videoId() {
      let source;
      if (innerWidth >= 1280) source = this.dataset.videoPc || this.dataset.videoTablet || this.dataset.videoMobile;
      else if (innerWidth >= 768) source = this.dataset.videoTablet || this.dataset.videoPc || this.dataset.videoMobile;
      else source = this.dataset.videoMobile || this.dataset.videoTablet || this.dataset.videoPc;
      return this.normalizeVideoId(source);
    }

    normalizeVideoId(source) {
      if (!source) return '';
      try {
        const url = new URL(source);
        if (url.hostname.includes('youtu.be')) return url.pathname.slice(1);
        return url.searchParams.get('v') || url.pathname.split('/').filter(Boolean).pop() || '';
      } catch {
        return source;
      }
    }

    embedUrl(videoId) {
      const parameters = new URLSearchParams({ playsinline: '1', rel: '0', modestbranding: '1', enablejsapi: '1', origin: location.origin });
      parameters.set('autoplay', '1');
      parameters.set('controls', '1');
      return `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?${parameters.toString()}`;
    }

    clamp(value) { return Math.max(0, Math.min(1, value)); }

    ease(value) { return value * value * (3 - 2 * value); }

    easeOut(value) { return 1 - ((1 - value) ** 3); }

    lerp(from, to, progress) { return from + ((to - from) * progress); }
  }

  customElements.define('anniversary-motion-film', AnniversaryMotionFilm);
}
